import { useState, useCallback } from "react";

export type LocationState = "anchor" | "underway";

interface UseNMEALocationReturn {
  anchorChecked: boolean;
  underwayChecked: boolean;
  location: LocationState;
  setAnchorChecked: (checked: boolean) => void;
  setUnderwayChecked: (checked: boolean) => void;
}

export const useNMEALocation = (
  initialLocation?: LocationState,
): UseNMEALocationReturn => {
  const [anchorChecked, setAnchorState] = useState(
    initialLocation === "anchor",
  );
  const [underwayChecked, setUnderwayState] = useState(
    initialLocation === "underway",
  );

  const setAnchorChecked = useCallback(
    (checked: boolean) => {
      // Don't allow unchecking if underway is also unchecked
      if (!checked && !underwayChecked) {
        return;
      }
      setAnchorState(checked);
      if (checked) {
        setUnderwayState(false);
      }
    },
    [underwayChecked],
  );

  const setUnderwayChecked = useCallback(
    (checked: boolean) => {
      // Don't allow unchecking if anchor is also unchecked
      if (!checked && !anchorChecked) {
        return;
      }
      setUnderwayState(checked);
      if (checked) {
        setAnchorState(false);
      }
    },
    [anchorChecked],
  );

  const location: LocationState =
    anchorChecked && !underwayChecked ? "anchor" : "underway";

  return {
    anchorChecked,
    underwayChecked,
    location,
    setAnchorChecked,
    setUnderwayChecked,
  };
};
